// components/AuthGuard.tsx
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { isAuthenticated } from "../../utils/auth";

export function AuthGuard() {
    const location = useLocation();
    if (!isAuthenticated()) {
        // send them to login; preserve the path they tried to access
        return <Navigate to="/login" replace state={{ from: location }} />;
    }
    return <Outlet />;
}

export function NoAuthGuard() {
    const location = useLocation();
    if (isAuthenticated()) {
        // send them to login; preserve the path they tried to access
        return <Navigate to="/dashboard" replace state={{ from: location }} />;
    }
    return <Outlet />;
}